export const LIST_THEME = [
  {
    demoPalette: ["#0756CD", "#99C2FF", "#82CD00", "#393939"],
    id: "blueSteel",
    themeName: "Blue Steel™",
    tokens: {
      colorPrimary: "#0756CD",
      colorSecondary: "#99C2FF",
      colorTertiary: "#82CD00",
      colorText: "#393939",
      sidebar_background: "#99C2FF",
    },
  },
  {
    demoPalette: ["#2F2F2F", "#fff", "#5F5F5F", "#DFDFDF"],
    id: "blackWhiteKeys",
    themeName: "Black & White Keys",
    tokens: {
      colorPrimary: "#2F2F2F",
      colorSecondary: "#fff",
      colorTertiary: "#5F5F5F",
      colorText: "#DFDFDF",
      sidebar_background: "#fff",
    },
  },
  {
    demoPalette: ["#028D00", "#A7DB8D", "#BEDEFF", "#525252"],
    id: "greenSkye",
    themeName: "GreenSkye",
    tokens: {
      colorPrimary: "#028D00",
      colorSecondary: "#A7DB8D",
      colorTertiary: "#BEDEFF",
      colorText: "#525252",
      sidebar_background: "#A7DB8D",
    },
  },
  {
    demoPalette: ["#A8A47A", "#D0E9C4", "#9AA2AF", "#383838"],
    id: "myDuneMyApplication",
    themeName: "My Dune, My Application®",
    tokens: {
      colorPrimary: "#A8A47A",
      colorSecondary: "#D0E9C4",
      colorTertiary: "#9AA2AF",
      colorText: "#383838",
      sidebar_background: "#D0E9C4",
    },
  },
];
